<script lang="ts">
    import type {ButtonStyle, ComponentSize} from '../../ui-components/types';
    import KpButton from '../../ui-components/button/KpButton.svelte';
    import {actionRequestMethods, states} from '../../constants/portaro.constants';
    import {createEventDispatcher} from 'svelte';
    import {getInjector} from '../../../svelte/context';
    import ActionRequestService from '../../services/action-request.service';

    export let path: string;
    export let requestMethod: string = actionRequestMethods.GET;
    export let requestBody: Record<string, unknown> = {};
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let isDisabled = false;
    export let title = '';
    export let additionalClasses = '';
    export let id: string = null;

    const dispatch = createEventDispatcher<{success: void}>();
    const actionRequestService = getInjector().getByToken<ActionRequestService>(ActionRequestService.serviceName)

    let state = states.INITIAL;

    async function performRequest(): Promise<void> {
        try {
            state = states.PROCESSING;
            await actionRequestService.action(path, requestMethod, requestBody);
            dispatch('success');
        } finally {
            state = states.NORMAL;
        }
    }

    let cssClasses: string;
    $: cssClasses = `kp-action-request-button ${additionalClasses} ${state === states.PROCESSING ? 'processing' : ''}`;

</script>

<template>
    <KpButton {buttonStyle} {buttonSize} {isDisabled} {title} {isBlock} additionalClasses={cssClasses} {id} on:click={performRequest}>
        <slot></slot>
    </KpButton>
</template>


<style lang="less" global>
    button.kp-action-request-button {
        transition: background-image 1s ease-in-out; /* plynule zobrazeni loadingu */
        background-image: none;

        &.processing {
            background-origin: content-box;
            color: transparent;

            &.btn-default {
                background: url('../../../../img/icon_loading_ring_24.gif') no-repeat 50% 50%;
            }

            &:not(.btn-default) {
                background: url('../../../../img/icon_loading_ring_white_24.gif') no-repeat 50% 50%;
            }
        }
    }
</style>